import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'domPurify',
})
export class DomPurifyPipe implements PipeTransform {
  private config: DOMPurify.Config = {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      'span',
      'div',
      'a',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'blockquote',
      'pre',
      'code',
      'b',
      'i',
      's',
      'strike',
      'del',
      'ins',
      'mark',
      'small',
      'sub',
      'sup',
    ],
    ALLOWED_ATTR: ['href', 'target', 'class', 'id', 'title', 'style', 'rel', 'src'],
    FORBID_ATTR: ['on*', 'xmlns', 'xlink:href', 'data', 'formaction', 'form', 'action', 'background'],
    KEEP_CONTENT: true,
    SANITIZE_DOM: false,
  };

  transform(value: string): string {
    if (!value) return '';

    return DOMPurify.sanitize(value, this.config);
  }
}

export class DomPurifyPipeUtility {
  static transform(value: string): string {
    return DomPurifyPipe.prototype.transform(value);
  }
}
